function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 20.25H19.5V3.75a1.502 1.502 0 00-1.5-1.5H6a1.502 1.502 0 00-1.5 1.5v16.5H2.25a.75.75 0 100 1.5h19.5a.75.75 0 100-1.5zm-6.375-7.125a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25z",
    fill: props.fill
  }));
}

export default SvgDoor;